exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#en .share-link[data-v-0346106d]{width:520px}", ""]);

// exports
